var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export var svgIcon = function (svg) {
    var Icon = function (_a) {
        var _b = _a.size, size = _b === void 0 ? 'medium' : _b, props = __rest(_a, ["size"]);
        var sizes = {
            xsmall: 12,
            small: 16,
            medium: 20,
            large: 32,
        };
        var dimension = "".concat(sizes[size], "px");
        var SvgIcon = svg;
        var ariaLabel = props['aria-label'];
        var ariaHidden = !ariaLabel ? true : undefined;
        var focusable = ariaLabel ? undefined : false;
        return (React.createElement(SvgIcon, __assign({ "aria-hidden": ariaHidden, focusable: focusable, height: dimension, width: dimension }, props)));
    };
    return Icon;
};
//# sourceMappingURL=svg-icon.js.map